import { render, staticRenderFns } from "./ModalHistoricoAlteracaoList.vue?vue&type=template&id=cd6b506a"
import script from "./ModalHistoricoAlteracaoList.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoAlteracaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports